import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SeasonalBanner from './SeasonalBanner';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from '@/components/ui/sonner';

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--c-cream))]">
      <SeasonalBanner />
      <Navbar />
      <main className="flex-1 page-fade-in" key={pathname}>
        <Outlet />
      </main>
      <Footer />
      <Toaster richColors position="top-center" />
    </div>
  );
}
